// Archivo para manejar cargas de archivos CSV/Excel
import React from 'react'
import { Button } from '@mui/material'
import * as XLSX from 'xlsx'
import { FIELD_STORAGE_OPTIONS } from './layoutUtils'

const normalizeName = (raw) => {
  return String(raw || '')
    .normalize('NFD') // elimina tildes
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9_]+/g, '_') // reemplaza todo lo que no sea a-z 0-9 _ por guión bajo
    .replace(/__+/g, '_') // reemplaza múltiples guiones bajos por uno solo
    .replace(/^_|_$/g, '') // elimina guión bajo inicial o final
}

const FileUpload = ({ setFields }) => {
  const handleFileUpload = (event) => {
    const file = event.target.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      const binaryStr = e.target.result
      const workbook = XLSX.read(binaryStr, { type: 'binary' })
      const sheet = workbook.Sheets[workbook.SheetNames[0]]
      const data = XLSX.utils.sheet_to_json(sheet, { header: 1 })

      if (data.length > 0) {
        const headers = data[0]
        const seenNames = new Set()
        const fields = []

        headers.forEach((col) => {
          const label = String(col || '').trim()
          const name = normalizeName(label)

          if (!name) {
            console.warn(`Campo ignorado: "${label}" tiene nombre inválido.`)
            return
          }

          if (seenNames.has(name)) {
            console.warn(`Campo duplicado ignorado: "${name}" ya existe.`)
            return
          }

          seenNames.add(name)
          fields.push({
            id: Date.now() + Math.random(),
            name,
            label,
            type: 'Texto',
            x: 0,
            y: 0,
            width: 150,
            height: 50,
            fontSize: 14,
            storage: FIELD_STORAGE_OPTIONS.CUSTOM_FIELDS,
            editable: false,
            color: '#000000',
            backgroundColor: '#ffffff',
          })
        })

        setFields(fields)
        console.log('[FileUpload] Campos generados desde archivo:', fields)
      }
    }

    reader.readAsBinaryString(file)
  }

  return (
    <Button variant="contained" component="label">
      Cargar Archivo
      <input
        type="file"
        hidden
        accept=".csv,.xlsx,.xls"
        onChange={handleFileUpload}
      />
    </Button>
  )
}

export default FileUpload
